import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { ValoreEconomicoAddRevisioneComponent } from './sezione-economica-valore-add-revisione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-valore-add-revisione]',
  templateUrl: 'sezione-economica-mod-valore-add-revisione.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModValoreEconomicoAddRevisioneComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formValoreEconomicoRevisione') formValoreEconomicoRevisione: ValoreEconomicoAddRevisioneComponent;

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean = false) {
    openModal('modaleValoreEconomicoRevisioneAdd');
      this.formValoreEconomicoRevisione.inizializza(sezione, petitumRevisione, fascicolo, urlInsert, recuperoCrediti);
  }

  createForm() {
      this.formValoreEconomicoRevisione.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleValoreEconomicoRevisioneAdd');
      this.onReturn.emit(sezioneEconomica);
  }
}
